import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '@/assets/img/credit-card.svg'
import _imports_1 from '@/assets/img/boleto.svg'


const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-auto" }
const _hoisted_3 = { class: "mb-0" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "",
  alt: ""
}, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "ms-3 fw-bold" }, "Cartão de crédito", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", {
  id: "card-number-info",
  class: "fw-bold"
}, " **** ", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "col text-end text-subtitle" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fas fa-chevron-right" })
], -1)
const _hoisted_8 = /*#__PURE__*/_createStaticVNode("<div class=\"row\"><div class=\"col-auto\"><h5 class=\"fw-bold mb-0\"><img src=\"" + _imports_1 + "\" class=\"\" alt=\"\"><span class=\"ms-3\">Boleto</span></h5></div><div class=\"col text-end text-subtitle\"><span class=\"fas fa-chevron-right\"></span></div></div>", 1)
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = {
  key: 0,
  class: "card text-primary bg-warning10 mx-2 mt-3",
  id: "boleto-unavailable-card"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "card-body" }, [
  /*#__PURE__*/_createElementVNode("h4", { class: "fw-bold" }, " Boleto indisponível "),
  /*#__PURE__*/_createTextVNode(" Indisponível no momento. O boleto só pode ser usado para sessões com pelo menos 7 dias de antecedência. ")
], -1)
const _hoisted_12 = [
  _hoisted_11
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: "border border-primary mt-3 p-4 rounded-5 text-primary cursor-pointer",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleSelectCard && _ctx.handleSelectCard(...args)))
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("h5", _hoisted_3, [
            _hoisted_4,
            _hoisted_5,
            (_ctx.paymentMethod?.type == 'card')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _hoisted_6,
                  _createTextVNode(),
                  _createElementVNode("span", null, _toDisplayString(_ctx.paymentMethod.info?.last_digits), 1)
                ], 64))
              : _createCommentVNode("", true)
          ])
        ]),
        _hoisted_7
      ])
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["border border-primary mt-3 p-4 rounded-5 text-primary cursor-pointer", { 'opacity-25': !_ctx.boletoAvailable }]),
      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleSelectBoleto && _ctx.handleSelectBoleto(...args)))
    }, _hoisted_9, 2),
    (!_ctx.boletoAvailable)
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, _hoisted_12))
      : _createCommentVNode("", true)
  ], 64))
}